import { axiosPrivate } from '../../api/connector'

export function getUsers(page: number = 1) {
    return axiosPrivate.get(`/v1/auth/users/?page=${page}`)
}
